import { render } from "./WorkloadDetailEndpoints.vue?vue&type=template&id=4c1a9fa8&scoped=true"
import script from "./WorkloadDetailEndpoints.vue?vue&type=script&lang=js"
export * from "./WorkloadDetailEndpoints.vue?vue&type=script&lang=js"

import "./WorkloadDetailEndpoints.vue?vue&type=style&index=0&id=4c1a9fa8&lang=scss&scoped=true"

import exportComponent from "../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1a9fa8"]])

export default __exports__